import React from 'react';
import { Link } from 'react-router-dom';

const LABELS = {
  work_order: (ref) => `Work order${ref ? ` #${ref}` : ''}`,
  maintenance_log: () => 'Maintenance log',
  follow_up: () => 'Follow-up on dashboard',
};

export const RequestOutcomeLink = ({ outcome, reference, recordId, machineryId, testId }) => {
  if (outcome === 'no_action') {
    return reference ? <p data-testid={testId} className="text-xs text-slate-700 whitespace-pre-wrap break-words">Note: {reference}</p> : null;
  }
  if (!outcome || !machineryId) return null;
  const query = outcome === 'work_order' ? `?workOrder=${recordId}` : '';
  return (
    <Link data-testid={testId} to={`/machinery/${machineryId}${query}`}
      className="text-xs text-blue-700 underline break-words">
      {LABELS[outcome]?.(reference) || 'Linked record'} →
    </Link>
  );
};
